// redux/slices/otherUserSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { getUserById } from "../actions/otherUserAction"; // Mevcut getUserById thunk’ünü kullanacağız

const initialState = {
  otherUser: {
    name: "",
    email: "",
    position: "",
    role: "",
    skills: [],
    gender: "",
    birthDate: "",
    address: "",
    telephone: "",
    about: "",
    social_medias: [],
    languages: [],
  },
  loading: false,
  error: null,
};

const otherUserSlice = createSlice({
  name: "otherUser",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserById.fulfilled, (state, action) => {
        state.loading = false;
        state.otherUser = {
          ...action.payload,
          skills: action.payload.skills || [],
        };
        
      })
      .addCase(getUserById.rejected, (state, action) => {
        console.error("❌ API isteği başarısız oldu:", action.payload);
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default otherUserSlice.reducer;
